import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { apiUrl } from "../../constants";
class Error extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang_check: "",
      language: [],
    };
  }

  render() {
    return (
      <div className="container" style={{ marginTop: "50px" }}>
        <div className="page-wrap d-flex flex-row align-items-center">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12 text-center">
                <div className="mb-4 lead">
                  {"404 not found"}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Error;
